import { render, staticRenderFns } from "./BestSystem.vue?vue&type=template&id=cd4f6cb0&"
import script from "./BestSystem.vue?vue&type=script&lang=js&"
export * from "./BestSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports